import { useContext } from "react";

import { Route, Redirect } from "react-router-dom";

import { AppContexts } from "./providers";
import moment from "moment";
import { usePermissionsStore } from "./components/permissions/permissions_store";

const AccessoryRoute = ({ component: Component, module, level = "view", ...rest }) => {
  let authCtx = useContext(AppContexts.AuthContext);
  const { canView, canEdit, isOwner, permsLoaded } = usePermissionsStore();

  console.log(
    "Products:",
    !authCtx.user?.details?.product.split(",").includes("extras"),
  );

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authCtx.user) {
          return (
            <Redirect
              to={{ pathname: "/auth/login", state: { from: props.location } }}
            />
          );
        } else if (
          authCtx.user &&
          (authCtx.user.details?.type === "expired" ||
            moment(
              ["trial", "trial-full"].includes(authCtx.user.details?.type) &&
                authCtx.user.details?.trial_end,
            ) < moment())
        ) {
          return (
            <Redirect
              to={{ pathname: "/expired", state: { from: props.location } }}
            />
          );
        } else if (
          !authCtx.user.details?.product.split(",").includes("extras")
        ) {
          return (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          );
        }

        if (module) {
          if (!permsLoaded) return null;

          const allowed = level === "edit" ? canEdit(module) : canView(module);
          if (!allowed) {
            return (
              <Redirect
                to={{
                  pathname: "/unauthorized",
                  state: { from: props.location, module },
                }}
              />
            );
          }
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default AccessoryRoute;
